<template>
  <div>
    <navbar/>
    <notes/>
  </div>
</template>

<script>

import notes from '@/components/notes.vue';
import navbar from '@/components/navbar.vue';

export default {
  name: 'DownloadView',
  components: {
    navbar, 
    notes, 
  }
}
</script>
